import { reviewFormValidator } from "@redotech/redo-form-builder-common/db-validator/review/review-form-builder-form-validator";
import * as z from "zod";

export const getActiveReviewForm = {
  name: "getActiveReviewForm" as const,
  input: z.null(),
  output: reviewFormValidator.nullable(),
};
